var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[(_vm.headerText)?_c('h4',[_vm._v(_vm._s(_vm.headerText))]):_vm._e(),_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.url,"id":"seltecFrame"},on:{"load":_vm.iframeLoaded}})])
}
var staticRenderFns = []

export { render, staticRenderFns }